const CHUNK_RELOAD_KEY = 'hr:chunk-reload-once';

export const clearChunkReloadFlags = () => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch {
    // ignore
  }
};

export const isChunkLoadError = (error) => {
  const message = String(error?.message || '').toLowerCase();
  return error?.name === 'ChunkLoadError'
    || message.includes('loading chunk')
    || message.includes('failed to fetch dynamically imported module')
    || message.includes('importing a module script failed');
};

export const recoverFromChunkLoadError = (error) => {
  if (!isChunkLoadError(error) || typeof window === 'undefined') {
    return false;
  }

  const hasRetried = window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
  if (!hasRetried) {
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
    return true;
  }

  clearChunkReloadFlags();
  return false;
};
